import script from "./plain_html.vue?vue&type=script&setup=true&lang=js"
export * from "./plain_html.vue?vue&type=script&setup=true&lang=js"

import "./plain_html.vue?vue&type=style&index=0&id=0fce5176&setup=true&lang=css"
/* custom blocks */
import block0 from "./plain_html.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__